"use strict";

/**
 * A Promise that resolves when CXF has been initialized
 *
 * Usage:
 *  const cxf = await require('cxf-ready')
 *
 */
var cxf = window && window.CXF;
module.exports = new Promise(function (resolve, reject) {
  if (!window) {
    reject();
  }

  if (cxf) {
    return resolve(cxf);
  }

  window.addEventListener('cxf.initialized', function (event) {
    cxf = event.cxf;
    resolve(cxf);
  }, {
    capture: true,
    once: true,
    passive: true
  });
});